import Vue from 'vue'
import dayjs from 'dayjs'

export function initFilters() {
    Vue.filter('dateDayMonth', date => {
        return dayjs(date).format('DD.MM')
    })

    Vue.filter('time', date => {
        return dayjs(date).format('HH:mm')
    })
}
